// extracted by mini-css-extract-plugin
export default {"button":"_96AL9___OverflowMenuItem-module__button"};